import { observer } from 'mobx-react';
import * as React from 'react';
import { ResourceAutoCompleteViewModelType } from '../../../../../extViewmodels';
import { LeadRuleViewModel } from '../../../../viewModels/leadrules';
import { SelectionPicker } from './SelectionPicker';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const DailyActivityTeamPicker: React.FC<IProps> = observer(({ leadRule }) => (
	<SelectionPicker<string>
		items={(leadRule?.dailyActivityTeams ?? []).map(name => ({ id: name, name }))}
		onAdd={selection => leadRule?.setDailyActivityTeams(leadRule?.dailyActivityTeams?.concat(selection))}
		onRemove={id => leadRule?.setDailyActivityTeams(leadRule?.dailyActivityTeams.filter(item => item !== id))}
		placeholder='Search Daily Team'
		type={ResourceAutoCompleteViewModelType.DailyActivityTeam}
	/>
));
